import React from 'react';
import { Row, Col, Card } from 'antd';
import {
    RocketOutlined,
    DatabaseOutlined,
    ProfileOutlined,
    SendOutlined,
    RollbackOutlined,
    PieChartOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const Home = () => {
    const navigate = useNavigate();

    const quickActions = [
        { key: 'serial', label: '串码管理', desc: '查看与管理串码', color: '#1890ff', bg: '#e6f7ff', icon: <DatabaseOutlined />, path: '/serial/list' },
        { key: 'order', label: '工单管理', desc: '生产工单列表', color: '#52c41a', bg: '#f6ffed', icon: <ProfileOutlined />, path: '/order/list' },
        { key: 'shipment', label: '发货报盘', desc: '批量发货报盘', color: '#fa8c16', bg: '#fff7e6', icon: <SendOutlined />, path: '/serial/shipment' },
        { key: 'return', label: '退货管理', desc: '批量退货管理', color: '#ff4d4f', bg: '#fff1f0', icon: <RollbackOutlined />, path: '/serial/return' },
    ];

    return (
        <div style={{ padding: '24px', minHeight: '100%' }}>
            {/* 顶部通栏 */}
            <div style={{
                background: 'linear-gradient(90deg, #5b64d1 0%, #8d62b6 100%)',
                padding: '40px',
                borderRadius: '12px',
                color: 'white',
                position: 'relative',
                marginBottom: '24px'
            }}>
                <h1 style={{ fontSize: '32px', marginBottom: '8px' }}>欢迎使用易莱孚生产管理后台</h1>
                <p style={{ opacity: 0.8 }}>生产系统的串码管理平台</p>
                <div style={{ position: 'absolute', right: '40px', bottom: '20px', fontSize: '64px', opacity: 0.2 }}>
                    <PieChartOutlined />
                </div>
            </div>

            {/* 快捷入口标题 */}
            <div style={{ marginBottom: '16px', fontWeight: 'bold', fontSize: '16px' }}>
                <RocketOutlined style={{ marginRight: '8px' }} /> 快捷入口
            </div>

            {/* 卡片区域 */}
            <Row gutter={[16, 16]}>
                {quickActions.map((item) => (
                    <Col span={6} key={item.key}>
                        <Card
                            hoverable
                            style={{ textAlign: 'center', borderRadius: '12px' }}
                            onClick={() => navigate(item.path)}
                        >
                            <div style={{ fontSize: '32px', color: item.color, marginBottom: '12px', background: item.bg, padding: '16px', borderRadius: '12px' }}>
                                {item.icon}
                            </div>
                            <h3 style={{ margin: '8px 0' }}>{item.label}</h3>
                            <p style={{ color: '#888', fontSize: '12px' }}>{item.desc}</p>
                        </Card>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default Home;
